import React from 'react';
import { Box, Typography } from '@mui/joy';
import { MediaLibrary as MediaLibraryComponent } from '../../components/marketing/MediaLibrary';

export const MediaLibrary: React.FC = () => {
  return (
    <Box sx={{ width: '100%' }}>
      <Typography level="body-md" sx={{ mb: 3, color: 'text.secondary' }}>
        Manage your marketing assets, including images and videos. Media tagged as "marketing" from production photos will also appear here.
      </Typography>

      <MediaLibraryComponent />
    </Box>
  );
};